<script>
import { Line } from "vue-chartjs";
export default {
    extends: Line,
    name: "LineChart",
    props: [
        'labels', 'datasets'
    ],
    mounted() {
        this.renderChart({
                labels: this.labels,
                datasets: this.datasets
            },
            { responsive: true, maintainAspectRatio: true }
        );
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/charts/LineChart.vue